import { AccountAvatar } from "@components/AccountIdentity/AccountAvatar";

interface LinkedAccountCardAvatarProps {
  imageUrl?: string;
  name?: string;
  useStorePlaceholder: boolean;
}

export const LinkedAccountCardAvatar = ({ imageUrl, name, useStorePlaceholder }: LinkedAccountCardAvatarProps) => {
  return (
    <AccountAvatar imageUrl={imageUrl} name={name} size={56} placeholder={useStorePlaceholder ? "store" : "none"} />
  );
};
